import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/orgs/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/orgs/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/orgs/updateById', data)
}
// 修改状态
export function updateStatusById (data) {
  return request.post('/business/orgs/updateStatusById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/orgs/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/orgs/delete/batch', {
    params: {
      ids
    }
  })
}
